exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "[data-v-0395481a] .md-menu-content.md-select-menu {\n  width: 150px;\n}\n.modal-container[data-v-0395481a] {\n  max-width: 600px;\n}\n\n/*.form-container {\r\n    height: 500px;\r\n}*/\n", ""]);

// exports
